// @ts-nocheck
import { Plugin } from '/usr/local/youhuiquan/coupon-ui-frontend-umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
